"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var createLogger = function createLogger() {
  // In our environments `dtrum` is injected as a global client-side
  if (typeof window.dtrum !== 'undefined' && typeof window.dtrum.reportError === 'function') {
    return window.dtrum.reportError;
  }

  // If `dtrum` isn't defined, we will return `newrelic` as a fallback if it is defined
  if (typeof window.newrelic !== 'undefined' && typeof window.newrelic.noticeError === 'function') {
    return window.newrelic.noticeError;
  }

  // If neither `dtrum`or `newrelic` are defined,
  // there may be other ways that window.onerror is picked up
  if (typeof window.onerror === 'function') {
    return window.onerror;
  }

  // eslint-disable-next-line
  return console.error;
};
var _default = exports["default"] = createLogger;